import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
import Payment from './Payment.vue';
import Socials from './Socials.vue';
export default {
  name: 'PaymentSocials',
  components: {
    Payment: Payment,
    Socials: Socials
  },
  props: {
    content: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};